

import dc_trip_1 from '../images/events/dc_trip/dc_trip_1.jpg'

import convention_1 from '../images/events/convention/convention_1.JPG'
import convention_2 from '../images/events/convention/convention_2.JPG'
import convention_3 from '../images/events/convention/convention_3.JPG'
import convention_4 from '../images/events/convention/convention_4.JPG'
import convention_5 from '../images/events/convention/convention_5.JPG'
import convention_6 from '../images/events/convention/convention_6.JPG'
import convention_7 from '../images/events/convention/convention_7.JPG'

const past_events = [
    {
        id: '1',
        eImg:dc_trip_1,
        date:"8 Apr, 2025",
        eTitle: 'Youth Leadership Trip to D.C.', 
        short_desc: 'We participated in the “Youth Leadership Program” with our amazing students in Washington D.C.',
        desc:'We participated in the “Youth Leadership Program” with our amazing students. Throughout the program, they had the chance to meet with staff from three different congressional offices, where they asked thoughtful questions and learned more about policymaking. They also worked on building their resumes, and even applying for internships on the Hill! They participated in a guided tour of key landmarks in DC. It was an intensive, inspiring experience that empowered our students to better understand leadership, civic engagement, and their own potential.',
        schedule_desc: 'Our schedule for the day included a mix of educational and interactive activities designed to engage students in the democratic process and inspire them to become active citizens.',
        schedule: [
            "Arrive at the Capitol Visitor Center",
            "Take a guided tour of the Capitol",
            "Meet with a local representative or staff",
            "Break for lunch",
            "Attend a youth leadership workshop",
            "Join a civic engagement panel and Q&A session",
            "Group reflection and discussion",
            "Return/depart from Capitol grounds",
          ],
        location: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6210.977363693306!2d-77.01162542326134!3d38.88993887172575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b82921a2cf17%3A0x482a3f7c10cf8c4!2sUnited%20States%20Capitol!5e0!3m2!1sen!2sus!4v1746213316783!5m2!1sen!2sus',
        register: 'https://docs.google.com/forms/d/e/1FAIpQLScScV50Klx0aqmLYb7jol7jhwt-vbw_f-h_Agl-xtIV1FCNvA/viewform?embedded=true',
        gallery: [
            dc_trip_1,
            dc_trip_1,
            dc_trip_1,
            dc_trip_1,
            dc_trip_1,
            dc_trip_1,
          ],
        
    },
    {
        id: '2',
        eImg:convention_1,
        date:"17 May, 2025",
        eTitle: '2025 Youth Convention', 
        short_desc: 'We organized our annual Youth Convention, where we addressed critical issues facing our communities in U.S.',
        desc:'We’re excited to officially welcome you to the Hill Academy 2025 Youth Convention, a full day of inspiration, action, and connection with youth from across the region. Get ready to learn from incredible speakers, collaborate on real-world issues, and have some fun along the way!',
        schedule_desc: 'Our schedule for the day included a series of speeches followed by workshops and group projects to encourage students to take action on the issues faced by their communities.',
        schedule: [
            "Arrival and Breakfast",
            "Speech on Education Inequality in U.S.",
            "Speech on Food Insecurity in U.S.",
            "Break for lunch",
            "Project development workshops",
            "Group project presentations",
            "Award ceremony and closing remarks",
          ],
        location: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.888671093411!2d-75.31648342319444!3d40.67642187139908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c46ae9f5ea0085%3A0x55d132d17c78b51c!2sMoravian%20Academy%20-%20Merle-Smith%20Campus!5e0!3m2!1sen!2sus!4v1747855139357!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade',
        register: 'https://docs.google.com/forms/d/e/1FAIpQLScScV50Klx0aqmLYb7jol7jhwt-vbw_f-h_Agl-xtIV1FCNvA/viewform?embedded=true',
        gallery: [
            convention_1,
            convention_2,
            convention_3,
            convention_4,
            convention_5,
            convention_6,
            convention_7,
          ],
        
    },
]

const future_events = [
]

export {past_events, future_events};